import type { FC } from "react";
import { useRef } from "react";
import type { Identifier } from "dnd-core";
import { useDrag, useDrop } from "react-dnd";
import { useDispatch } from "react-redux";

import { AppDispatch } from "../../../redux/reducer/store";
import { actionAddDesktop } from "../../../redux/action/charts/actionCharts";


interface IDragQualityChart {
  key: number;
  index: number;
  id: number;
  moveHorizontalChart: (index: number, id: number) => void;
  moveVerticallyChart: (index: number, id: number) => void;
  el: any;
};

interface DragItem {
  index: number;
  id: string;
  type: string;
};

const DragManagementChart: FC<IDragQualityChart> = ({ id, index, moveHorizontalChart, moveVerticallyChart, el }) => {
  const dispatch: any = useDispatch<AppDispatch>();

  const ref = useRef<HTMLDivElement>(null);

  const [{ handlerId }, drop] = useDrop<
    DragItem,
    void,
    { handlerId: Identifier | null }
  >({
    accept: 'chart',
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(item: DragItem, monitor) {
      if (!ref.current) {
        return;
      }
    
      const dragIndex = item.index;
      const hoverIndex = index;
    
      if (dragIndex === hoverIndex) {
        return;
      }
    
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
    
      const clientOffset = monitor.getClientOffset();
    
      if (!clientOffset || !hoverBoundingRect) {
        return;
      }
    
      const hoverMiddleX =
        hoverBoundingRect.left + (hoverBoundingRect.width / 2);
      const cursorPositionX = clientOffset.x;
    
      if (cursorPositionX < hoverMiddleX && dragIndex > hoverIndex) {
        moveHorizontalChart(dragIndex, hoverIndex);
        item.index = hoverIndex;
      }
    
      if (cursorPositionX > hoverMiddleX && dragIndex < hoverIndex) {
        moveHorizontalChart(dragIndex, hoverIndex);
        item.index = hoverIndex;
      }
    },

    drop(item: DragItem, monitor) {
      dispatch(actionAddDesktop());
    }
  });

  const [{ isDragging }, drag] = useDrag({
    type: 'chart',
    item: () => {
      return { id, index };
    },
    collect: (monitor: any) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const opacity = isDragging ? 0.5 : 1;
  drag(drop(ref));
  return (
    <div ref={ref} data-handler-id={handlerId as any} style={{ opacity: opacity }}>
      {el}
    </div>
  )
}

export default DragManagementChart;